var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMoreHorizontal(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "more-horizontal"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.99984 11.1432C5.45817 11.1432 5.83317 10.7682 5.83317 10.3099C5.83317 9.85156 5.45817 9.47656 4.99984 9.47656C4.5415 9.47656 4.1665 9.85156 4.1665 10.3099C4.1665 10.7682 4.5415 11.1432 4.99984 11.1432Z",
    stroke: "#8D8D8D",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.99984 11.1432C10.4582 11.1432 10.8332 10.7682 10.8332 10.3099C10.8332 9.85156 10.4582 9.47656 9.99984 9.47656C9.5415 9.47656 9.1665 9.85156 9.1665 10.3099C9.1665 10.7682 9.5415 11.1432 9.99984 11.1432Z",
    stroke: "#8D8D8D",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.9998 11.1432C15.4582 11.1432 15.8332 10.7682 15.8332 10.3099C15.8332 9.85156 15.4582 9.47656 14.9998 9.47656C14.5415 9.47656 14.1665 9.85156 14.1665 10.3099C14.1665 10.7682 14.5415 11.1432 14.9998 11.1432Z",
    stroke: "#8D8D8D",
    strokeWidth: 1.5
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoreHorizontal);
export default __webpack_public_path__ + "static/media/more-horizontal.60f7036bb0f498b690d83329b9c378d9.svg";
export { ForwardRef as ReactComponent };